var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndividual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.003,16.996 C-0.003,16.996 -0.003,15.088 -0.003,15.088 C-0.003,11.676 2.908,8.911 6.498,8.911 C6.498,8.911 6.499,8.911 6.499,8.911 C10.089,8.911 13.000,11.676 13.000,15.088 C13.000,15.088 13.000,16.996 13.000,16.996 C13.000,16.996 -0.003,16.996 -0.003,16.996 ZM6.499,7.820 C4.228,7.820 2.387,6.071 2.387,3.914 C2.387,1.756 4.228,0.008 6.499,0.008 C8.769,0.008 10.609,1.756 10.609,3.914 C10.609,6.071 8.769,7.820 6.499,7.820 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividual);
export default ForwardRef;